export default __webpack_public_path__ + "locales/az/Common.json?hash=af252b8feb07caa1f7851a36116f90c8";